import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MedicationRouteNamePipe } from 'src/app/pipes/medication-route-name.pipe';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { MedicationInfusionRedLabelInstructionsV3 } from 'src/app/types/sheet-instruction.types';
import { InstructionBoxComponent } from '../../instruction-box/instruction-box.component';
import { ItemContentComponent } from '../../item-content/item-content.component';

@Component({
    selector: 'app-medication-infusion-red-label-item-v3',
    templateUrl: './medication-infusion-red-label-item-v3.component.html',
    styleUrl: './medication-infusion-red-label-item-v3.component.scss',
    imports: [ItemContentComponent, InstructionBoxComponent, MedicationRouteNamePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationInfusionRedLabelItemComponentV3 implements SheetItemComponentBase {

	row!: Row;
	instructions!: MedicationInfusionRedLabelInstructionsV3;
	@Input() startLabel!: string;
	@Input() endLabel!: string;
	@Input('row') set updateRow(row: Row) {
		this.row = row;
		this.instructions = row.instructions as MedicationInfusionRedLabelInstructionsV3;
	}

	constructor() {
	}
}